import { Component, DestroyRef, Inject, inject } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { BreadcrumbComponent } from '../../elements/breadcrumb/breadcrumb.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { Notification, AllNotifications } from '../../models/permissions.model';
import { NgxToastrService } from '../../_services/ngx-toastr/ngx-toastr.service';
import { Subscription } from 'rxjs';
import { HttpServiceService } from '../../services/http-service.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-create-notifications',
  imports: [ReactiveFormsModule, BreadcrumbComponent, NgFor, FormsModule, NgClass, NgIf],
  templateUrl: './create-notifications.component.html',
  styleUrl: './create-notifications.component.css'
})
export class CreateNotificationsComponent {
  breadcrumbList = {
    breadcrumb_path: 'Dashboard',
    currentURL: 'Owners',
    breadcrumb_url: '/admin/owners'
  }
  searchForFeatures: string = '';
  allFeaturesList: AllNotifications[] = [];
  filteredFeaturesList: AllNotifications[] = [];
  selectedIndex: number = 0;
  displayNotificationsList: boolean = false;
  selectedFeatureName: string = '';
  notifications!: AllNotifications;
  notificationsForm!: FormGroup;
  private httpService = inject(HttpServiceService);
  private getAllNotificationsSubscription: Subscription | undefined;
  private updateNotificationSubscription: Subscription | undefined;
  private destroyRef = inject(DestroyRef);
  constructor(private fb: FormBuilder, private alertService: NgxToastrService) { }

  ngOnInit() {
    this.notificationsForm = new FormGroup({
      notifications: new FormArray([])
    });
    this.getAllNotifications();
  }
  
  getAllNotifications() {
    this.getAllNotificationsSubscription = this.httpService.getAllNotifications().subscribe({
      next: (response) => { 
        this.allFeaturesList = response.data ?? [];
        this.filteredFeaturesList = [...this.allFeaturesList];
        this.displayNotifications();
      }
    });
  }


  createForm(notifications: AllNotifications) {
    let notificationsList = notifications.roles ?? [];
    this.notificationsArray?.clear();
    notificationsList.forEach((notification: any) => {
      const group = new FormGroup({
        role_identifier: new FormControl(notification.role_identifier),
        role_name: new FormControl(notification.role_name),
        role_id: new FormControl(notification.role_id),
        email: new FormControl(notification.email),
        sms: new FormControl(notification.sms),
        whatsapp: new FormControl(notification.whatsapp),
      });
      this.notificationsArray.push(group);
      
      group.get('email')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: boolean) => {
        this.updateNotification({ channel : 'email' , status: value, role_id: group.get('role_id')?.value });
      });

      group.get('sms')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: boolean) => {
        this.updateNotification({ channel : 'sms', status: value, role_id: group.get('role_id')?.value });
      });

      group.get('whatsapp')?.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value: boolean) => {
        this.updateNotification({ channel : 'whatsapp', status: value, role_id: group.get('role_id')?.value });
      });
    });
  }

  filterFeatures() {
    if (this.searchForFeatures) {
      this.filteredFeaturesList = this.allFeaturesList.filter((item: { action_name: string; }) =>
        item.action_name.toLowerCase().includes(this.searchForFeatures?.toLowerCase())
      );
    } else {
      this.filteredFeaturesList = [...this.allFeaturesList];
    }
  }

  selectFeature(index: number, feature: any): void {
    this.selectedIndex = index;
    this.selectedFeatureName = feature?.['action_name'] ?? '';
    this.notifications = feature;
    this.createForm(feature);
  }

  displayNotifications() {
    let defaultData = this.filteredFeaturesList[this.selectedIndex];
    this.displayNotificationsList = true;
    this.selectFeature(this.selectedIndex, defaultData);
  }

  updateNotification(notification: any) {
    let selctedRoleData = this.filteredFeaturesList[this.selectedIndex];
    let data = {
      action_id: selctedRoleData.action_id,
      role_id: notification.role_id,
      channel: notification.channel,
      status: notification.status
    };
    this.updateNotificationSubscription = this.httpService.updateNotification(data).subscribe({
      next: (response) => {
        selctedRoleData.roles = selctedRoleData.roles?.map((role: any) => {
          if (role.role_id === notification.role_id) {
            role[notification.channel] = notification.status;
          }
          return role;
        });
        this.alertService.success(response.message, 'toast-top-right');        
      }
    }); 
  }

  get notificationsArray() {
    return this.notificationsForm?.get('notifications') as FormArray;
  }

  ngOnDestroy() {
    if (this.getAllNotificationsSubscription) {
      this.getAllNotificationsSubscription.unsubscribe();
    }
    if (this.updateNotificationSubscription) {
      this.updateNotificationSubscription.unsubscribe();
    }
  }

}
